<div class="builder-wrapper" :class="{ 'preview-mode': previewMode, 'editor-open': isAdmin && builderOpen && !previewMode }">
  <!-- ========== DESIGN PANEL (Sidebar) ========== -->
  <transition name="slide-panel">
    <aside v-if="isAdmin && builderOpen && !previewMode" class="design-panel">
      <!-- Panel Top Bar -->
      <div class="panel-top-bar">
        <div class="save-indicator" :class="saveStatus">
          <template v-if="saveStatus === 'saving'">
            <i class="bi bi-arrow-repeat spin"></i> Saving...
          </template>
          <template v-else-if="saveStatus === 'saved'">
            <i class="bi bi-check-circle-fill"></i> Saved
          </template>
          <template v-else-if="saveStatus === 'error'">
            <i class="bi bi-exclamation-circle-fill"></i> Error
          </template>
          <template v-else>
            <i class="bi bi-cloud-check"></i> Auto-save enabled
          </template>
        </div>
        <button class="close-panel-btn" @click="builderOpen = false" title="Close panel">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <!-- Panel Tabs -->
      <div class="panel-tabs">
        <button :class="{ active: activePanel === 'content' }" @click="activePanel = 'content'">
          <i class="bi bi-text-paragraph"></i> Content
        </button>
        <button :class="{ active: activePanel === 'style' }" @click="activePanel = 'style'">
          <i class="bi bi-brush"></i> Style
        </button>
        <button :class="{ active: activePanel === 'layout' }" @click="activePanel = 'layout'">
          <i class="bi bi-grid-3x3"></i> Layout
        </button>
      </div>

      <div class="panel-content">
        <!-- ===== CONTENT TAB ===== -->
        <!-- What text/content is displayed -->
        <div v-if="activePanel === 'content'" class="tab-content">
          <!-- Main Content Section -->
          <div class="section-header">
            <i class="bi bi-type me-1"></i> Text Content
          </div>

          <div class="field-group">
            <label><i class="bi bi-type-h1 me-1"></i> Title</label>
            <input type="text" v-model="title" @change="autoSave" class="field-input">
          </div>

          <div class="field-group">
            <label><i class="bi bi-chat-text me-1"></i> Message</label>
            <textarea v-model="message" @change="autoSave" rows="3" class="field-input"></textarea>
            <small class="hint">Supports HTML</small>
          </div>

          <div class="field-group">
            <label><i class="bi bi-info-circle me-1"></i> Additional Info</label>
            <textarea v-model="additional_info" @change="autoSave" rows="2" class="field-input"></textarea>
          </div>

          <div class="divider"></div>

          <!-- Support Section -->
          <div class="section-header">
            <i class="bi bi-headset me-1"></i> Support Contact
          </div>

          <div class="field-group">
            <label>Section Heading</label>
            <input type="text" v-model="support_heading" @change="autoSave" class="field-input" placeholder="Need help?">
          </div>

          <div class="field-group">
            <label><i class="bi bi-envelope me-1"></i> Email</label>
            <input type="email" v-model="support_email" @change="autoSave" class="field-input" placeholder="support@company.com">
          </div>

          <div class="field-group">
            <label><i class="bi bi-whatsapp me-1"></i> WhatsApp</label>
            <input type="text" v-model="support_whatsapp" @change="autoSave" class="field-input" placeholder="+27 12 345 6789">
            <small class="hint">Include country code</small>
          </div>

          <div class="field-group">
            <label><i class="bi bi-telephone me-1"></i> Phone</label>
            <input type="text" v-model="support_phone" @change="autoSave" class="field-input" placeholder="+27 12 345 6789">
          </div>
        </div>

        <!-- ===== STYLE TAB ===== -->
        <!-- How things look (colors, appearance) -->
        <div v-if="activePanel === 'style'" class="tab-content">
          <!-- Quick Presets Section -->
          <div class="section-header">
            <i class="bi bi-stars me-1"></i> Quick Presets
          </div>

          <div class="field-group">
            <div class="preset-grid">
              <button class="preset-btn" @click="applyPreset('minimal')">
                <span class="preset-preview minimal"></span>
                Minimal
              </button>
              <button class="preset-btn" @click="applyPreset('modern')">
                <span class="preset-preview modern"></span>
                Modern
              </button>
              <button class="preset-btn" @click="applyPreset('vibrant')">
                <span class="preset-preview vibrant"></span>
                Vibrant
              </button>
              <button class="preset-btn" @click="applyPreset('dark')">
                <span class="preset-preview dark"></span>
                Dark
              </button>
            </div>
          </div>

          <div class="divider"></div>

          <!-- Background Section -->
          <div class="section-header">
            <i class="bi bi-paint-bucket me-1"></i> Page Background
          </div>

          <div class="field-group">
            <div class="btn-group-sm">
              <button :class="{ active: styles.background_type === 'solid' }" @click="styles.background_type = 'solid'; autoSave()">Solid</button>
              <button :class="{ active: styles.background_type === 'gradient' }" @click="styles.background_type = 'gradient'; autoSave()">Gradient</button>
              <button :class="{ active: styles.background_type === 'image' }" @click="styles.background_type = 'image'; autoSave()">Image</button>
            </div>
            
            <div v-if="styles.background_type === 'solid'" class="color-row mt-2">
              <input type="color" v-model="styles.background_color" @change="autoSave">
              <input type="text" v-model="styles.background_color" @change="autoSave" class="color-text">
            </div>
            
            <div v-if="styles.background_type === 'gradient'" class="gradient-controls mt-2">
              <div class="color-row">
                <span>From</span>
                <input type="color" v-model="styles.gradient_from" @change="autoSave">
                <input type="text" v-model="styles.gradient_from" @change="autoSave" class="color-text">
              </div>
              <div class="color-row">
                <span>To</span>
                <input type="color" v-model="styles.gradient_to" @change="autoSave">
                <input type="text" v-model="styles.gradient_to" @change="autoSave" class="color-text">
              </div>
              <div class="slider-row">
                <span>Angle</span>
                <input type="range" v-model="styles.gradient_angle" min="0" max="360" @input="autoSave">
                <span class="value">{{ styles.gradient_angle }}°</span>
              </div>
            </div>
            
            <div v-if="styles.background_type === 'image'" class="mt-2">
              <input type="text" v-model="styles.background_image" @change="autoSave" placeholder="Image URL..." class="field-input">
            </div>
          </div>

          <div class="divider"></div>

          <!-- Card Appearance -->
          <div class="section-header">
            <i class="bi bi-card-heading me-1"></i> Card Appearance
          </div>

          <div class="field-group">
            <label>Background</label>
            <div class="color-row">
              <input type="color" v-model="styles.card_background" @change="autoSave">
              <input type="text" v-model="styles.card_background" @change="autoSave" class="color-text">
            </div>
          </div>

          <div class="field-group">
            <label>Shadow</label>
            <div class="btn-group-sm">
              <button :class="{ active: styles.card_shadow === 'none' }" @click="styles.card_shadow = 'none'; autoSave()">None</button>
              <button :class="{ active: styles.card_shadow === 'small' }" @click="styles.card_shadow = 'small'; autoSave()">S</button>
              <button :class="{ active: styles.card_shadow === 'medium' }" @click="styles.card_shadow = 'medium'; autoSave()">M</button>
              <button :class="{ active: styles.card_shadow === 'large' }" @click="styles.card_shadow = 'large'; autoSave()">L</button>
            </div>
          </div>

          <div class="divider"></div>

          <!-- Colors Section -->
          <div class="section-header">
            <i class="bi bi-palette me-1"></i> Text & Icon Colors
          </div>

          <div class="field-group">
            <label>Primary / Icon</label>
            <div class="color-row">
              <input type="color" v-model="styles.primary_color" @change="autoSave">
              <input type="text" v-model="styles.primary_color" @change="autoSave" class="color-text">
            </div>
          </div>

          <div class="field-group">
            <label>Title</label>
            <div class="color-row">
              <input type="color" v-model="styles.title_color" @change="autoSave">
              <input type="text" v-model="styles.title_color" @change="autoSave" class="color-text">
            </div>
          </div>

          <div class="field-group">
            <label>Message</label>
            <div class="color-row">
              <input type="color" v-model="styles.message_color" @change="autoSave">
              <input type="text" v-model="styles.message_color" @change="autoSave" class="color-text">
            </div>
          </div>
        </div>

        <!-- ===== LAYOUT TAB ===== -->
        <!-- Structure, sizing, and arrangement -->
        <div v-if="activePanel === 'layout'" class="tab-content">
          <!-- Components Section -->
          <div class="section-header">
            <i class="bi bi-list-check me-1"></i> Components
          </div>
          <p class="hint mb-2">Toggle visibility and drag to reorder</p>

          <div class="component-list">
            <div 
              v-for="(comp, name) in components" 
              :key="name"
              class="component-item"
              :class="{ disabled: !comp.visible }"
              draggable="true"
              @dragstart="onDragStart($event, name)"
              @dragover="onDragOver($event, name)"
              @dragend="onDragEnd"
            >
              <div class="drag-handle">
                <i class="bi bi-grip-vertical"></i>
              </div>
              <div class="component-info">
                <span class="component-name">{{ name.charAt(0).toUpperCase() + name.slice(1) }}</span>
              </div>
              <div class="component-actions">
                <button class="move-btn" @click="moveComponent(name, 'up')" :disabled="comp.order === 0">
                  <i class="bi bi-chevron-up"></i>
                </button>
                <button class="move-btn" @click="moveComponent(name, 'down')" :disabled="comp.order === Object.keys(components).length - 1">
                  <i class="bi bi-chevron-down"></i>
                </button>
                <label class="visibility-toggle">
                  <input type="checkbox" :checked="comp.visible" @change="toggleComponent(name)">
                  <i :class="comp.visible ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
                </label>
              </div>
            </div>
          </div>

          <div class="divider"></div>

          <!-- Typography Sizing -->
          <div class="section-header">
            <i class="bi bi-fonts me-1"></i> Typography Size
          </div>

          <div class="field-group">
            <label>Title Size</label>
            <div class="slider-row">
              <input type="range" v-model="styles.title_size" min="20" max="48" @input="autoSave">
              <span class="value">{{ styles.title_size }}px</span>
            </div>
          </div>

          <div class="field-group">
            <label>Message Size</label>
            <div class="slider-row">
              <input type="range" v-model="styles.message_size" min="12" max="24" @input="autoSave">
              <span class="value">{{ styles.message_size }}px</span>
            </div>
          </div>

          <div class="divider"></div>

          <!-- Spacing Section -->
          <div class="section-header">
            <i class="bi bi-arrows-angle-expand me-1"></i> Spacing & Dimensions
          </div>

          <div class="field-group">
            <label>Card Padding</label>
            <div class="slider-row">
              <input type="range" v-model="styles.card_padding" min="16" max="80" @input="autoSave">
              <span class="value">{{ styles.card_padding }}px</span>
            </div>
          </div>

          <div class="field-group">
            <label>Card Corners</label>
            <div class="slider-row">
              <input type="range" v-model="styles.card_border_radius" min="0" max="48" @input="autoSave">
              <span class="value">{{ styles.card_border_radius }}px</span>
            </div>
          </div>

          <div class="field-group">
            <label>Icon Size</label>
            <div class="slider-row">
              <input type="range" v-model="styles.icon_size" min="48" max="120" @input="autoSave">
              <span class="value">{{ styles.icon_size }}px</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Panel Footer -->
      <div class="panel-footer">
        <button class="done-btn" @click="goToConfirmWorkflow">
          <i class="bi bi-check-lg"></i> Done
        </button>
      </div>
    </aside>
  </transition>

  <!-- ========== TOGGLE BUTTON ========== -->
  <button v-if="isAdmin && !builderOpen && !previewMode" class="toggle-panel-btn" @click="builderOpen = true">
    <i class="bi bi-sliders"></i>
  </button>

  <!-- ========== PREVIEW TOGGLE ========== -->
  <div v-if="isAdmin" class="preview-toggle">
    <button :class="{ active: !previewMode }" @click="previewMode = false; previewViewport = 'desktop'">
      <i class="bi bi-pencil-square"></i> Edit
    </button>
    <button :class="{ active: previewMode }" @click="previewMode = true">
      <i class="bi bi-eye"></i> Preview
    </button>
  </div>

  <!-- ========== VIEWPORT SELECTOR (Preview Mode Only) ========== -->
  <div v-if="isAdmin && previewMode" class="viewport-selector">
    <button 
      :class="{ active: previewViewport === 'desktop' }" 
      @click="previewViewport = 'desktop'"
      title="Desktop (1200px+)"
    >
      <i class="bi bi-display"></i>
    </button>
    <button 
      :class="{ active: previewViewport === 'tablet' }" 
      @click="previewViewport = 'tablet'"
      title="Tablet (768px)"
    >
      <i class="bi bi-tablet"></i>
    </button>
    <button 
      :class="{ active: previewViewport === 'mobile' }" 
      @click="previewViewport = 'mobile'"
      title="Mobile (375px)"
    >
      <i class="bi bi-phone"></i>
    </button>
  </div>

  <!-- ========== MAIN CANVAS ========== -->
  <main class="canvas-area" :class="['viewport-' + previewViewport, { 'preview-active': previewMode, 'no-panel': !isAdmin || !builderOpen }]" :style="backgroundStyle">
    <!-- Decorative shapes -->
    <div class="bg-shapes">
      <div class="bg-shape shape-1"></div>
      <div class="bg-shape shape-2"></div>
    </div>

    <div class="canvas-content">
      <div v-if="is_loading" class="loading-state">
        <div class="spinner"></div>
      </div>

      <div v-else class="thank-you-card" :style="cardStyle">
        <div class="card-inner" :style="{ padding: styles.card_padding + 'px' }">
          
          <!-- Dynamic component rendering based on order -->
          <template v-for="compName in sortedComponents" :key="compName">
            
            <!-- Logo -->
            <div v-if="compName === 'logo' && components.logo.visible" class="block-logo">
              <img v-if="$clientLogo" :src="$clientLogo" class="logo-img" alt="Logo">
            </div>

            <!-- Success Icon -->
            <div v-if="compName === 'icon' && components.icon.visible" class="block-icon" :style="iconStyle">
              <div class="success-circle">
                <svg class="checkmark" viewBox="0 0 52 52">
                  <circle class="checkmark-circle" cx="26" cy="26" r="25" fill="none"/>
                  <path class="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                </svg>
              </div>
              <div class="ripple"></div>
            </div>

            <!-- Title -->
            <div v-if="compName === 'title' && components.title.visible" class="block-title">
              <h1 :style="titleStyle">{{ title }}</h1>
            </div>

            <!-- Message -->
            <div v-if="compName === 'message' && components.message.visible" class="block-message">
              <p :style="messageStyle">{{ message }}</p>
            </div>

            <!-- Info -->
            <div v-if="compName === 'info' && components.info.visible && additional_info" class="block-info">
              <div class="info-box">
                <i class="bi bi-info-circle"></i>
                <span>{{ additional_info }}</span>
              </div>
            </div>

            <!-- Support -->
            <div v-if="compName === 'support' && components.support.visible" class="block-support">
              <div class="support-section">
                <p class="support-heading">{{ support_heading }}</p>
                <div class="support-options">
                  <a 
                    v-if="support_email" 
                    :href="'mailto:' + support_email" 
                    class="support-option"
                    :style="{ color: styles.primary_color }"
                  >
                    <i class="bi bi-envelope-fill"></i>
                    <span>Email</span>
                  </a>
                  <a 
                    v-if="support_whatsapp" 
                    :href="'https://wa.me/' + support_whatsapp.replace(/[^0-9]/g, '')" 
                    target="_blank"
                    class="support-option whatsapp"
                  >
                    <i class="bi bi-whatsapp"></i>
                    <span>WhatsApp</span>
                  </a>
                  <a 
                    v-if="support_phone" 
                    :href="'tel:' + support_phone" 
                    class="support-option"
                    :style="{ color: styles.primary_color }"
                  >
                    <i class="bi bi-telephone-fill"></i>
                    <span>Call</span>
                  </a>
                </div>
              </div>
            </div>
          </template>

        </div>
      </div>
    </div>
  </main>
</div>
